import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnswerRenderer from '../AnswerRenderer';
import './AnswerAttribute.scss';
import { getRequest } from '../../../requestUtils';

class AnswerAttribute extends Component {
  constructor(props) {
    super(props);
    this.updateSingleAnswer = this.updateSingleAnswer.bind(this);
  }

  updateSingleAnswer(answer) {
    const {
      questionableId,
      questionableType,
      updateCompletionPercentage,
      updateAnswers,
    } = this.props;
    if (!answer) return;

    getRequest(
      `/question_answers/${answer.id}`,
      { questionable_id: questionableId, questionable_type: questionableType },
    ).then(() => {
      updateCompletionPercentage();
      updateAnswers();
    });
  }

  render() {
    const {
      customClass,
      fullView,
      questionableId,
      questionableType,
      csrfToken,
      editMode,
      questionnaireName,
      hideFooterButton,
      answer,
      handleNewResume,
    } = this.props;

    return (
      <div className={`answer-attribute ${customClass}`}>
        <div>
          <AnswerRenderer
            key={answer.id}
            answer={answer}
            editMode={editMode}
            csrfToken={csrfToken}
            questionnaireName={questionnaireName}
            questionableId={questionableId}
            questionableType={questionableType}
            fullView={fullView}
            closeModalCallback={this.updateSingleAnswer}
            hideFooterButton={hideFooterButton}
            editable={fullView}
            handleNewResume={handleNewResume}
          />
        </div>
      </div>
    );
  }
}

AnswerAttribute.propTypes = {
  customClass: PropTypes.string,
  answer: PropTypes.shape({}).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  fullView: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  questionnaireName: PropTypes.string.isRequired,
  hideFooterButton: PropTypes.bool,
  updateCompletionPercentage: PropTypes.func,
  updateAnswers: PropTypes.func.isRequired,
  handleNewResume: PropTypes.func,
};

AnswerAttribute.defaultProps = {
  customClass: '',
  fullView: true,
  editMode: false,
  hideFooterButton: false,
  updateCompletionPercentage: () => {},
  handleNewResume: () => {},

};

export default AnswerAttribute;
